import { render } from "./modalVideoPlayer.vue?vue&type=template&id=5310048c&scoped=true"
import script from "./modalVideoPlayer.vue?vue&type=script&lang=js"
export * from "./modalVideoPlayer.vue?vue&type=script&lang=js"

import "./modalVideoPlayer.vue?vue&type=style&index=0&id=5310048c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5310048c"]])

export default __exports__